import { Component, OnInit, Input } from '@angular/core';
import { MainService } from '../../services/main.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  @Input() miniVersion: boolean;

  constructor(private mainService: MainService) {
  }

  ngOnInit() { }

}
